// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__17R2F","counter":"loader_counter__tI_1p","heading":"loader_heading__EWpI7","text":"loader_text__tkvKX","content":"loader_content__8DbZY"};